export const GeringfuegigeBeschaeftigung = [
  {
    'PAISY Wert': 0,
    Bezeichnung: 'keine geringfügige Beschäftigung',
  },
  {
    'PAISY Wert': 1,
    Bezeichnung: 'geringfügig entlohnte Beschäftigung',
  },
  {
    'PAISY Wert': 2,
    Bezeichnung: 'kurzfristige Beschäftigung',
  },
];
